import React, { Component } from 'react';
import { withTranslation, Trans } from 'react-i18next';
import ConfiguratorSection from '../ConfiguratorSection';
import ConfiguratorImage from '../ConfiguratorImage';
import ConfiguratorOption from '../ConfiguratorOption';
import RadioGroup from './../RadioGroup';
import Disclaimer from '../Disclaimer';
import { view02ImageOptions } from './views/view02'

class Bowsprit extends Component {
    constructor(props) {
        super(props);

        this.handleBowspritChange = this.handleBowspritChange.bind(this);
    }

    handleBowspritChange(newValue) {
        let configuration = this.props.configuration;
        configuration.BowSprit = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }
   

    render() {
        let imageOptions = view02ImageOptions;

        let image = (
            <ConfiguratorImage boat="X4_3MK2" configuration={this.props.configuration} options={imageOptions} />
        );


        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption style={{position:'relative'}}>

                    <h1><Trans defaults='Bowsprit' /></h1>

                    <RadioGroup label={this.props.t("Optional bowsprits:")} options={this.props.bowSpritOptions} value={this.props.configuration.BowSprit} onChange={this.handleBowspritChange} />

                    <Disclaimer />
                   

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(Bowsprit);


// WEBPACK FOOTER //
// ./src/X43MK2/Bowsprit.js